import { Box, Flex } from '@pancakeswap/uikit'
import styled, { createGlobalStyle } from 'styled-components'

export const StyledSwapContainer = styled(Flex)<{ $isChartExpanded: boolean }>`
  flex-shrink: 0;
  height: fit-content;
  padding: 0 24px;

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0 40px;
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    ${({ $isChartExpanded }) => ($isChartExpanded ? 'padding: 0 120px' : 'padding: 0 40px')};
  }
`

export const StyledInputCurrencyWrapper = styled(Box)`
  width: min(428px, calc(100vw - 48px));
`

export const CustomHeading = createGlobalStyle`
  @font-face {
    font-family: 'MyCustomFont';
    src: url('/fonts/ChakraPetch-Bold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  body {
    font-family: 'MyCustomFont', sans-serif;
  }
`
